function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "layer1",
  transform: "translate(-668.58 -15.171)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g19554",
  transform: "translate(668.58 15.171)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path19407",
  d: "M650.864,51.545h34.764V40.183H665.164V.827h-14.3V51.545Z",
  transform: "translate(-650.864 0.001)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path19411",
  d: "M857.663,20.09H838.539v-8.2h20.309V.827H824.239V51.545h35.713V40.411H838.539V31.079h19.124Z",
  transform: "translate(-781.323 0.001)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path19415",
  d: "M1025.382,39.1c-6.951,0-11.143-6.4-11.143-15.426,0-8.807,4.271-15.426,11.143-15.426s10.984,6.619,10.984,15.349c0,9.18-4.031,15.5-10.984,15.5m-.473,10.761c16.356,0,26.626-10.386,26.626-26.712,0-13.547-8.691-25.664-25.839-25.664-16.354,0-26.467,11.739-26.467,26.489,0,14.073,9.089,25.886,25.6,25.886Z",
  transform: "translate(-912.997 2.518)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path19419",
  d: "M1257.573,51.545V39.055c0-8.2-.155-15.876-.555-22.725h.318a202.914,202.914,0,0,0,9.007,18.358l9.007,16.857h15.012V.827h-13.038V12.791a182.271,182.271,0,0,0,1.108,21.374h-.237a181,181,0,0,0-8.375-17.76L1261.368.827h-16.832V51.545Z",
  transform: "translate(-1097.581 0.001)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path19421",
  d: "M1478.894,51.545H1493.2V.827h-14.307Z",
  transform: "translate(-1273.927 0.001)"
})));

var SvgLeoni = function SvgLeoni(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219.274,
    height: 52.376,
    viewBox: "0 0 219.274 52.376",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeoni, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/leoni.f1093b30.svg";
export { ForwardRef as ReactComponent };